import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURL = 'nominas/entidad-municipal-otros-datos';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

export const getEntidadesMunicipalesOtrosDatos = async () => {
  try {
    const response = await API.get(baseURL);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

export const getEntidadMunicipalOtrosDatos = async (id) => {
  try {
    const response = await API.get(`${baseURL}/${id}`);
    return await response.data;
  } catch (error) {
    onError(error);
    return null;
  }
};

export const postEntidadMunicipalOtrosDatos = async (values) => {
  try {
    const response = await API.post(baseURL, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente.');
    return response.data;
  } catch (error) {
    onError(error);
    return false;
  }
};

export const patchEntidadMunicipalOtrosDatos = async (id, values) => {
  try {
    const response = await API.patch(`${baseURL}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (error) {
    onError(error);
    return false;
  }
};

export const deleteEntidadMunicipalOtrosDatos = async (id) => {
  try {
    const response = await API.delete(`${baseURL}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (error) {
    onError(error);
    return false;
  }
};
